import { api } from '@/lib/api';

// Single fetch of the admin-managed active-redirect map, cached app-wide so
// both RedirectGate and the NotFound catch-all share it without racing.
let cache = null;

export function loadRedirects() {
  if (!cache) {
    cache = api.get('/redirects/active')
      .then((r) => {
        const m = {};
        (r.data.redirects || []).forEach((d) => { m[d.source] = d; });
        return m;
      })
      .catch(() => ({}));
  }
  return cache;
}

export function normalizePath(p) {
  if (!p) return '/';
  let x = p.split('#')[0].split('?')[0].toLowerCase();
  if (!x.startsWith('/')) x = '/' + x;
  if (x.length > 1) x = x.replace(/\/+$/, '');
  return x || '/';
}
